import { Component, Input, OnInit } from "@angular/core";
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexGrid,
  ApexLegend,
  ApexPlotOptions,
  ApexYAxis
} from "ng-apexcharts";

type ApexXAxis = {
  type?: "category" | "datetime" | "numeric";
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
};

@Component({
  selector: "app-columns-chart",
  templateUrl: "./columns.component.html",
  styleUrls: ["./columns.component.scss"]
})
export class ColumnsChartComponent implements OnInit {
  @Input() dataSeries: [];
  @Input() chartName: string;
  @Input() canshowAxis: boolean;
  lables = [
    'Today',
    'Yesterday',
    'This Week',
    'This Month',
  ];

  public chartOptions: Partial<ChartOptions>;
  constructor() {
  }

  ngOnInit() {
    this.chartOptions = {
      series: [
        {
          name: this.chartName,
          data: this.dataSeries
        }
      ],
      chart: {
        height: 120,
        toolbar: {
          show: false,
        },
        type: "bar",
        events: {
          click: function (chart, w, e) {
          }
        }
      },
      colors: [
        "#FEB019",
        "#00E396",
        "#FF4560",
        "#ED61EE",
      ],
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
          colors: {
            backgroundBarColors: ["#ffffff"],
            backgroundBarOpacity: 1,
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      grid: {
        show: false
      },
      xaxis: {
        categories: this.lables,
        labels: {
          style: {
            colors: [
              "#FEB019",
              "#00E396",
              "#FF4560",
              "#ED61EE",
            ],
            fontSize: "0"
          }
        }
      },
      yaxis: {
        show: this.canshowAxis ? true : false,
      },
    };
  }
}